module.exports = __webpack_public_path__ + "img/go-2.5feae633.svg";